import { Action, combineReducers } from '@ngrx/store';

import { IBackAuthUsersState } from './users.state';
import { BackAuthUsersExternalFeatureKey, BackAuthUsersExternalReducer } from './external/users-external.reducer';
import { BackAuthUsersInternalFeatureKey, BackAuthUsersInternalReducer } from './internal/users-internal.reducer';
import { BackAuthUsersGlobalFeatureKey, BackAuthUsersGlobalReducer } from '@apps/back/store/auth/users/global/users-global.reducer';

export function BackAuthUsersReducers (state: IBackAuthUsersState | undefined, action: Action)
{
    return combineReducers({
        [BackAuthUsersExternalFeatureKey]: BackAuthUsersExternalReducer,
        [BackAuthUsersInternalFeatureKey]: BackAuthUsersInternalReducer,
        [BackAuthUsersGlobalFeatureKey]: BackAuthUsersGlobalReducer
    })(state, action);
}
